import React from 'react';
import SubscriptionFeatureFlags from '../components/subscription/SubscriptionFeatureFlags';

const AdminFeatureFlagsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Admin Feature Flags</h1>
          <p className="mt-2 text-gray-600">
            Configure subscription feature flags and enforcement modes
          </p>
        </div>
        
        <SubscriptionFeatureFlags />
      </div>
    </div>
  );
};

export default AdminFeatureFlagsPage;
